/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Information_DetailsInputs */

const en_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project information details`)
};

const fr_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails des informations du projet`)
};

const de_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektinformationen Details`)
};

const it_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli delle informazioni sul progetto`)
};

const ru_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подробная информация о проекте`)
};

const es_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de la información del proyecto`)
};

const zh_cn2_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目信息详情`)
};

const ja_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト情報の詳細`)
};

const hi_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना संबंधी जानकारी का विवरण`)
};

const pt_pt2_project_information_details = /** @type {(inputs: Project_Information_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes das informações do projeto`)
};

/**
* | output |
* | --- |
* | "Project information details" |
*
* @param {Project_Information_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_information_details = /** @type {((inputs?: Project_Information_DetailsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Information_DetailsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_information_details(inputs)
	if (locale === "de") return de_project_information_details(inputs)
	if (locale === "it") return it_project_information_details(inputs)
	if (locale === "ru") return ru_project_information_details(inputs)
	if (locale === "es") return es_project_information_details(inputs)
	if (locale === "zh-CN") return zh_cn2_project_information_details(inputs)
	if (locale === "ja") return ja_project_information_details(inputs)
	if (locale === "hi") return hi_project_information_details(inputs)
	if (locale === "pt-PT") return pt_pt2_project_information_details(inputs)
	return en_project_information_details(inputs)
});